import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ControllerBase } from 'src/app-client/_appCommon/base/ControllerBase';
import { GlobalConstants } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';
import { Product, Service, ShoppingCartItem } from '../../_appCommon/base/AppInterfaceAndBaseClasses';
import { ProductType } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';

@Component({
  selector: 'app-shopping-cart-sidebar',
  templateUrl: './shopping-cart-sidebar.component.html',
  styleUrls: ['./shopping-cart-sidebar.component.css']
})
export class ShoppingCartSidebarComponent extends ControllerBase
{
  @ViewChild('sidebar') sidebar: ElementRef;

  @HostListener('document:click', ['$event'])
  clickOutOfElement(event: any): void
  {
    event.stopPropagation();

    if (!this.sidebar.nativeElement.contains(event.target) && event.target.id !== 'shoppingCartButton' && event.target.id !== 'btn-delete-product-shopping-cart')
    {
      this.showShoppingCart = false;
      this.shoppingCartDataService.onShowShoppingCart(this.showShoppingCart);
    }
  }

  public currentCart: ShoppingCartItem[];
  public defaultImage = GlobalConstants.altProductImagePath;
  public showShoppingCart: boolean = false;

  constructor(
    private router: Router,
    public shoppingCartDataService: ShoppingCartDataService,
  )
  {
    super();
  }

  ngOnInit(): void
  {
    this.shoppingCartDataService.getItems()
      .subscribe(cart =>
      {
        this.currentCart = cart;
      });

    this.shoppingCartDataService.showShoppingCart
      .subscribe(showShoppingCart =>
      {
        this.showShoppingCart = showShoppingCart;
      });
  }

  public toggleShow(): void
  {
    this.showShoppingCart = !this.showShoppingCart;
    this.shoppingCartDataService.onShowShoppingCart(this.showShoppingCart);
  }

  public getItemImage(images: any, item: Product): string
  {
    if (this.shoppingCartDataService.isProduct(item))
    {
      return images.length > 0 ? images[0].url : this.defaultImage;
    }
    else
    {
      return images.url ?? this.defaultImage;
    }
  }

  public onRemoveItem(itemIndex: number): void
  {
    this.setInfoAlert(this.shoppingCartDataService.onDeleteItem(itemIndex));
  }

  public onUpdateQuantityItem(itemIndex: number, quantity: number): void
  {
    this.shoppingCartDataService.onUpdateQuantityItem(itemIndex, quantity);
  }

  public get getSubtotal(): number
  {
    return this.shoppingCartDataService.getSubtotal();
  }

  public get getTax(): number
  {
    return this.shoppingCartDataService.getTax();
  }

  public get getTotal(): number
  {
    return this.shoppingCartDataService.getTotal();
  }

  public get getCaseId(): number
  {
    return this.shoppingCartDataService.caseId;
  }

  public get getCasePatientName(): string
  {
    return this.shoppingCartDataService.casePatientName;
  }

  public isDisabledItemQuantityChange(item: Product | Service): boolean
  {
    return this.getCaseId && this.isProduct(item);
  }

  public onProcessPurchase(): void
  {
    this.router.navigate(['ecommerce/checkout']);
  }

  public onGoStore(): void
  {
    this.toggleShow();
    this.router.navigate(['ecommerce/tienda']);
  }

  public isProduct(item: Product | Service): boolean
  {
    return this.shoppingCartDataService.isProduct(item);
  }

  public isAccesoryProductType(item: any): boolean
  {
    return item?.productType == ProductType.Accessory;
  }

  isSetupProduct(product: any ):boolean {
    if(product.hasOwnProperty('productType')){
      return product.productType == ProductType.Setup;
    }
    return false;
  }

  public getTotalByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getTotalByItem(itemCart);
  }

  public getTaxByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getTaxByItem(itemCart);
  }

  public getSubtotalByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getSubtotalByItem(itemCart);
  }
}
